'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _CommunicationSelectedMethodCall = require('ui-addon-upgrades/_core/communicationMethods/CommunicationSelectedMethodCall');

var _CommunicationSelectedMethodCall2 = _interopRequireDefault(_CommunicationSelectedMethodCall);

var _communicationMethodTypes = require('ui-addon-upgrades/_core/communicationMethods/communicationMethodTypes');

var _communicationMethodTypes2 = _interopRequireDefault(_communicationMethodTypes);

var _tracker = require('ui-addon-upgrades/_core/common/eventTracking/tracker');

var tracker = _interopRequireWildcard(_tracker);

var _MeetingPrompt = require('ui-addon-upgrades/_core/communicationMethods/MeetingPrompt');

var _meetingLinks = require('ui-addon-upgrades/_core/common/constants/meetingLinks');

var _meetingHelpers = require('ui-addon-upgrades/_core/common/api/meetingHelpers');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MEETING = _communicationMethodTypes2.default.MEETING,
    CALL = _communicationMethodTypes2.default.CALL;
exports.default = [{
  communicationKey: CALL,
  image: 'calling-small',
  SelectedMethodComponent: _CommunicationSelectedMethodCall2.default,
  onClick: function onClick(propsToPass) {
    tracker.track('communicationMethodsInteraction', _extends({
      action: 'clicked contact sales with phone call'
    }, propsToPass.upgradeData));
  }
}, {
  communicationKey: MEETING,
  image: 'meetings-small',
  SelectedMethodComponent: null,
  onClick: function onClick(propsToPass) {
    var onClose = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
    var upgradeData = propsToPass.upgradeData,
        onCancel = propsToPass.onCancel;
    var repInfo = upgradeData.repInfo;

    var linkBase = repInfo && repInfo.link ? repInfo.link : _meetingLinks.ISC_CALENDAR_LINK;
    var meetingLink = linkBase + '?' + (0, _meetingHelpers.getInlineMeetingParams)(upgradeData);

    tracker.track('communicationMethodsInteraction', _extends({
      action: 'clicked contact sales with meeting'
    }, upgradeData));

    (0, _MeetingPrompt.MeetingPrompt)({ meetingLink: meetingLink, upgradeData: upgradeData, onCancel: onCancel });

    tracker.track('communicationMethodsInteraction', _extends({
      action: 'shown booking page',
      meetingLink: linkBase
    }, upgradeData));

    onClose();
  }
}];
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.1086/js/_core/communicationMethods/communicationMethodsConfig.js
// module id = 296
// module chunks = 3 4 5